module.exports = __webpack_public_path__ + "sm.c4ee42b3.svg";